import { useContext, useEffect, useState } from "react";
import { Row, Col, Table, Button, Checkbox, Divider, Flex } from "antd";

import {
	TableDropdownFilter,
	TableGlobalSearchAnimated,
	TablePageSize,
	TablePagination,
	TableShowingEntriesV2,
	useTableScrollOnTop,
} from "../../../../providers/CustomTableFilter";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/pro-regular-svg-icons";

import ModalUploadExamResult from "./ModalUploadExamResult";
import ModalExamResultPreview from "./ModalExamResultPreview";
import dayjs from "dayjs";
import PageApplicantContext from "./PageApplicantContext";

export default function TableExamResult() {
	const { location, tableFilter, setTableFilter, dataStudentExam } = useContext(
		PageApplicantContext
	);

	const [
		toggleModalUploadExamResult,
		setToggleModalUploadExamResult,
	] = useState({ open: false, data: null });

	const [
		toggleModalExamResultPreview,
		setToggleModalExamResultPreview,
	] = useState({
		open: false,
		data: null,
	});

	const examResult = dataStudentExam?.data?.data?.[0]?.exam_result;

	useTableScrollOnTop("tblExamResult", location.pathname);

	useEffect(() => {
		if (tableFilter.isTrash === 1) {
			setTableFilter((prev) => ({
				...prev,
				isTrash: 0,
			}));
		}
	}, [tableFilter.isTrash]);

	return (
		<>
			<Row gutter={[12, 12]} id="tbl_wrapper_examresult">
				<Col xs={24} sm={24} md={24} lg={24}>
					<div className="tbl-top-filter">
						<Flex gap={10} align="flex-start">
							<Col className="p-0">
								<Button
									type="primary"
									className="btn-main-primary"
									onClick={() => {
										setToggleModalUploadExamResult({
											open: true,
											data: null,
										});
									}}
								>
									Upload Exam Result
								</Button>
							</Col>
							<TableGlobalSearchAnimated tableFilter={tableFilter} />
						</Flex>

						<Flex vertical gap={12} align="flex-end">
							<TablePageSize
								tableFilter={tableFilter}
								setTableFilter={setTableFilter}
							/>

							<Flex className="tbl-bottom-filter">
								<div />

								<Flex>
									<TableShowingEntriesV2 />
									<TablePagination
										tableFilter={tableFilter}
										setTableFilter={setTableFilter}
										setPaginationTotal={dataStudentExam?.data?.total}
										showLessItems={true}
										showSizeChanger={false}
										tblIdWrapper="tbl_wrapper_approval"
									/>
								</Flex>
							</Flex>
						</Flex>
					</div>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24}>
					<Table
						id="tblExamResult"
						className="ant-table-default ant-table-striped"
						dataSource={dataStudentExam && dataStudentExam.data.data}
						rowKey={(record) => record.id}
						pagination={false}
						bordered={false}
						scroll={{ x: "max-content" }}
						sticky
					>
						<Table.Column
							title="Preview Result"
							key="preview_attachment"
							align="center"
							width={100}
							render={(_, record) => {
								// console.log("record test: ", record);

								return (
									<Button
										type="link"
										className="color-1"
										onClick={() => {
											setToggleModalExamResultPreview({
												open: true,
												data: record,
											});
										}}
										disabled={examResult != null ? false : true}
									>
										<FontAwesomeIcon icon={faEye} />
									</Button>
								);
							}}
						/>

						<Table.Column
							title="Answer Sheet No."
							key="exam_sheet_number"
							dataIndex="exam_sheet_number"
							width={150}
							render={(text, record) => <>{record.answer_sheet_no ?? "N/A"}</>}
							sorter={(a, b) => a.answer_sheet_no - b.answer_sheet_no}
						/>

						<Table.Column
							title="Student Name"
							key="fullname"
							dataIndex="fullname"
							sorter={(a, b) => a.fullname.localeCompare(b.fullname)}
							render={(text, record) => {
								const fullname = record.fullname;
								return <>{` ${fullname} `}</>;
							}}
							width={150}
						/>

						<Table.Column
							title="Student Status"
							key="student_status"
							dataIndex="student_status"
							sorter={(a, b) =>
								a.student_status.localeCompare(b.student_status)
							}
							width={150}
						/>

						<Table.Column
							title="Exam Schedule"
							key="exam_schedule_id"
							dataIndex="exam_schedule_id"
							sorter={(a, b) => a.exam_category.localeCompare(b.exam_category)}
							defaultSortOrder="ascend"
							width={250}
							render={(text, record) => (
								<>
									{dayjs(record.exam_date).format("MMMM DD, YYYY")} ({" "}
									{record.exam_time} )
								</>
							)}
						/>

						<Table.Column
							title="Exam Category"
							key="exam_category_id"
							dataIndex="exam_category_id"
							sorter={(a, b) => a.exam_category_id - b.exam_category_id}
							render={(text, record) => {
								return <>{record.exam_category}</>;
							}}
							width={150}
						/>
					</Table>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
					<Flex className="tbl-bottom-filter">
						<div />

						<Flex>
							<TableShowingEntriesV2 />
							<TablePagination
								tableFilter={tableFilter}
								setTableFilter={setTableFilter}
								setPaginationTotal={dataStudentExam?.data?.total}
								showLessItems={true}
								showSizeChanger={false}
								tblIdWrapper="tbl_wrapper_approval"
							/>
						</Flex>
					</Flex>
				</Col>
			</Row>

			<ModalUploadExamResult
				toggleModalUploadExamResult={toggleModalUploadExamResult}
				setToggleModalUploadExamResult={setToggleModalUploadExamResult}
				dataSource={dataStudentExam}
				tableFilter={tableFilter}
				setTableFilter={setTableFilter}
			/>

			<ModalExamResultPreview
				toggleModalExamResultPreview={toggleModalExamResultPreview}
				setToggleModalExamResultPreview={setToggleModalExamResultPreview}
			/>
		</>
	);
}
